<template>
	<section id="vd" class="text-center w-100 bg-gray py-4 py-lg-5 px-3 px-lg-0">
		<b-container class="py-lg-5 px-3">
			<b-row class="bg-white">
				<b-col cols="12" lg="6" class="p-lg-5" order="2" order-lg="1">
					<b-row>
						<b-col cols="12" class="text-center pt-4 py-lg-5">
							<h3 class="pt-2 pt-lg-0 px-4 px-lg-0 px-xl-5">
								<span v-if="$creo.getLang() == 'sv'">En stark avslutning på ett speciellt år</span>
								<span v-else>A strong end to a special year</span>
							</h3>
						</b-col>
						<b-col cols="10" offset="1">
							<p>
								<span v-if="$creo.getLang() == 'sv'">Stark försäljning och stabil nivå produktionsstarter, trots pandemin. Under 2020 har JM visat prov på en mycket bra anpassningsförmåga.</span>
								<span v-else>Strong sales and a stable level of housing starts, despite the pandemic. In 2020, JM has proven that it is highly adaptable.
								</span>
							</p>
						</b-col>
						<b-col cols="10" offset="1" class="py-2 py-lg-4">
							<h6 class="mb-0 px-3 text-gray-medium">
								<span v-if="$creo.getLang() == 'sv'">Stockholm i februari 2021</span>
								<span v-else>Stockholm, February 2021</span>
							</h6>
							<h6 class="pt-1 px-3 text-gray-medium">
								<span v-if="$creo.getLang() == 'sv'">Johan Skoglund, <span class="italic">Verkställande direktör och koncernchef</span></span>
								<span v-else>Johan Skoglund, <span class="italic">President and CEO</span></span>
							</h6>
						</b-col>
						<b-col cols="12" class="text-center pb-4">
							<a 	:href="$creo.browserPdfLink(pdfLink.org[$creo.getLang()], pdfLink.fallback[$creo.getLang()], pdfLink.page[$creo.getLang()])"
								target="_blank"
								class="btn btn-link pt-3 italic text-decoration-none standard-white">
								<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
								<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
							</a>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="12" lg="6" class="pl-lg-5 px-0" order="1" order-lg="2">
					<div class="ceo"/>
				</b-col>
			</b-row>
		</b-container>
	</section>
</template>
<script>
	export default {
		props: {
			pdfLink: Object
		},
		methods: {
			viewHandler(e) {
				// console.log(e)
			}
		}
	}
</script>

<!-- <span v-if="$creo.getLang() == 'sv'"></span>
<span v-else>	</span> -->
